/**
 * Os atalhos de periodo dos Monitoramentos Compartilhados.
 *
 * Moram no CONCEITO, e nao na listagem, porque e o conceito que publica `periodStart` e
 * `periodEnd` no endereco - o dono do parametro e o dono do vocabulario.
 *
 * `all` vem primeiro e e o estado inicial: esta tela sempre abriu sem recorte de data, e
 * trocar isso por "ultimos 30 dias" mudaria calado o que ela lista.
 *
 * Nao ha tabela de codigos aqui, ao contrario das outras telas de periodo, porque o atalho
 * NAO viaja no endereco: o que viaja sao as duas datas, como sempre viajou. Quem reabre um
 * link salvo ve as datas com "Escolher datas" marcado, que e a leitura honesta - o atalho
 * era so o caminho ate elas.
 */
export const MONITORING_SHORTCUTS = ['all', '7d', '30d', '90d', '12m', 'custom'];
//# sourceMappingURL=monitoring.periods.js.map